// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import {combineReducers} from "redux";
import * as appSettings from "./applicationReducer";
import * as connections from "./connectionsReducer";
import * as currentProject from "./currentProjectReducer";
import * as recentProjects from "./recentProjectsReducer";
import * as appError from "./appErrorReducer";
import * as appTitle from "./appTitleReducer";
import * as prebuiltSettings from "./prebuiltSettingsReducer";
import * as adHocOcr from "./adHocOcrReducer";
import * as autoLabelModels from "./autoLabelModelManagementReducer";
import * as autoLabelMetrics from "./metricsReducer";
import * as adHocOcrV2 from "./adHocOcrV2Reducer";
import * as adHocOcrGroup from "./adHocOcrGroupReducer";
import * as adHocOcrV3 from "./adHocOcrV3Reducer";
import * as adHocOcrV3Group from "./adHocOcrGroupV3Reducer";


/**
 * All application reducers
 * @member appSettings - Application Settings reducer
 * @member connections - Connections reducer
 * @member recentProjects - Recent Projects reducer
 * @member currentProject - Current Project reducer
 * @member appError = Application error
 */
export default combineReducers({
    appSettings: appSettings.reducer,
    connections: connections.reducer,
    recentProjects: recentProjects.reducer,
    currentProject: currentProject.reducer,
    appError: appError.reducer,
    appTitle: appTitle.reducer,
    prebuiltSettings: prebuiltSettings.reducer,
    adHocOcr: adHocOcr.reducer,
    autoLabelState: autoLabelModels.reducer,
    metricState: autoLabelMetrics.reducer,
    adHocOcrV2: adHocOcrV2.reducer, 
    adHocOcrGroup: adHocOcrGroup.reducer, 
    adHocOcrV3: adHocOcrV3.reducer, 
    adHocOcrV3Group: adHocOcrV3Group.reducer
});
